import type {ChangeEventHandler, SyntheticEvent} from 'react'
import {useState} from 'react'
import {Button} from '@freckle/educator-materials/ts/components/button'
import {Flex} from '@freckle/educator-materials/ts/components/flex'
import {Label} from '@freckle/educator-materials/ts/components/label'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {inviteForm} from './invite-teacher-form.module.scss'

type Props = {
  onSubmit: (name: string, email: string) => Promise<unknown>
}

export function InviteTeacherForm(props: Props) {
  const {onSubmit} = props
  const {t} = useSafeTranslation()

  const [name, setName] = useState<string>('')
  const [email, setEmail] = useState<string>('')

  function handleNameChange(e: SyntheticEvent<HTMLInputElement, InputEvent>) {
    if (e.currentTarget instanceof HTMLInputElement) {
      setName(e.currentTarget.value)
    }
  }

  function handleEmailChange(e: SyntheticEvent<HTMLInputElement, InputEvent>) {
    if (e.currentTarget instanceof HTMLInputElement) {
      setEmail(e.currentTarget.value)
    }
  }

  function handleSubmit(e: SyntheticEvent<EventTarget, Event>) {
    e.preventDefault()

    onSubmit(name, email).then(() => {
      setName('')
      setEmail('')
    })
  }

  return (
    <div className={inviteForm}>
      <Label>{t('MANAGE_TEACHERS_INVITE_TEACHER_FORM_LABEL')}</Label>
      <Flex>
        <input
          type="text"
          placeholder={t('MANAGE_TEACHERS_INVITE_TEACHER_FORM_TEACHER_NAME_PLACEHOLDER')}
          value={name}
          onChange={handleNameChange as unknown as ChangeEventHandler}
          data-test="invite-teacher-name"
        />
        <input
          type="email"
          placeholder={t('MANAGE_TEACHERS_INVITE_TEACHER_FORM_TEACHER_EMAIL_PLACEHOLDER')}
          value={email}
          onChange={handleEmailChange as unknown as ChangeEventHandler}
          data-test="invite-teacher-email"
        />
        <Button onClick={handleSubmit} style="secondary" dataTest="invite-teacher-btn">
          {t('MANAGE_TEACHERS_INVITE_TEACHER_FORM_INVITE_TEACHER_BUTTON')}
        </Button>
      </Flex>
    </div>
  )
}
